var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 2
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17595"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 203",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    d: "M18 1H0"
  }))));
}

export default __webpack_public_path__ + "216e716d1a920cc76eac911b66d77ae7.svg";
export { SvgMinus as ReactComponent };